// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__BNxdE","errorLogs":"EditorFooter_errorLogs__3hna6"};